<template>
  <v-card tile outlined>
    <table class="text-left job-info-table">
      <thead>
        <slot name="head" :headers="headers">
          <tr class="text-title-small">
            <th v-for="(header, index) in headers" :key="`header-${index}`">
              {{ header }}
            </th>
          </tr>
        </slot>
      </thead>
      <tbody v-if="isLoading">
        <tr>
          <td v-for="(header, index) in headers" :key="`loading-header-${index}`">
            <v-skeleton-loader type="text" width="70%" />
          </td>
        </tr>
      </tbody>
      <tbody v-else>
        <slot v-if="rows.length > 0 || ignoreEmpty" name="body" :rows="rows">
          <tr v-for="(row, rowIndex) in rows" :key="`row-${rowIndex}`">
            <td v-for="(column, columnIndex) in row" :key="`row-${rowIndex}-column-${columnIndex}`">
              <slot :name="`cell-${rowIndex}-${columnIndex}`">
                {{ column }}
              </slot>
            </td>
          </tr>
        </slot>
        <tr v-else>
          <td :colspan="headers.length">
            Nothing to display
          </td>
        </tr>
      </tbody>
    </table>
  </v-card>
</template>

<script>
export default {
  props: {
    headers: { type: Array, required: true },
    ignoreEmpty: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false },
    rows: { type: Array, required: true }
  }
}
</script>

<style lang="scss">
.job-info-table {
  border-collapse: collapse;
  width: 100%;

  thead > tr, tbody > tr:not(:last-child) {
    border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  }

  th {
    font-weight: 500;
    padding: 20px;
  }

  td {
    font-size: 15px;
    padding: 20px;
  }
}
</style>
